import React, { useState } from "react";
import filter from "../assets/images/filter.png";
import exportPic from "../assets/images/export.png";
import { Link } from "react-router-dom";
import Upcoming from "../components/livestream/upcoming/Upcoming";
import Ongoing from "../components/livestream/ongoing/Ongoing";
import Completed from "../components/livestream/completed/Completed";
import { canPerformAction } from "../utils/denyAccess";

const initialState = {
  upcoming: true,
  ongoing: false,
  completed: false,
};
const LivestreamManagement = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { upcoming, ongoing, completed } = iState;
  const handleSelect = (name) => {
    setUpdateState((prev) => ({
      ...prev,
      upcoming: false,
      ongoing: false,
      completed: false,
      [name]: true,
    }));
  };

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        {upcoming && (
          <div className="TitleBox justify-content-end mt-2">
            {canPerformAction("Livestream") && (
              <Link to={"livestreamAdd"} className="TitleLink">
                <i className="fa-solid fa-plus" /> Add New Livestream
              </Link>
            )}
          </div>
        )}
        <div className="Small-Wrapper">
          <div className="row">
            <div className="col-md-7">
              <div className="CommonTabs">
                <ul className="nav nav-pills nav-fill">
                  <li
                    className="nav-item"
                    onClick={() => handleSelect("upcoming")}
                  >
                    <a className={`nav-link ${upcoming ? "active" : ""}`}>
                      Upcoming
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => handleSelect("ongoing")}
                  >
                    <a className={`nav-link ${ongoing ? "active" : ""}`}>
                      Ongoing
                    </a>
                  </li>
                  <li
                    className="nav-item"
                    onClick={() => handleSelect("completed")}
                  >
                    <a className={`nav-link ${completed ? "active" : ""}`}>
                      Completed
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="tab-content">
            {upcoming && <Upcoming />}
            {ongoing && <Ongoing />}
            {completed && <Completed />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LivestreamManagement;
